import { RecipeImage } from "@/utils/constant";

const AddFULLAEMURL = (text: string) => {

  if (!text) {
    return "";
  }
  let newText = text.replaceAll(
    "/content/dam/empire",
    RecipeImage + "/content/dam/empire"
  );
  newText = newText.replaceAll("https://www.sobeys.com/en/", "/");
  newText= newText.replaceAll("videos.html?", "videos?");
  return newText;
};

export { AddFULLAEMURL };
